/**
 * خطأٌ جاء من الخادم — <b>ورمزُه هو العقد، لا نصُّه</b>.
 *
 * الخادمُ يردّ `ProblemDetails` ومعه `code` ثابت (`identity.invalid_credentials`،
 * `intake.price_needs_permission`، …). وصياغةُ الرسالة تتغيّر ولا يكسر تغييرُها
 * شيئًا؛ أمّا الرمزُ فعليه تُبنى القرارات. ولهذا لا تُقارَن الرسائلُ في أيّ
 * شاشة، ولا تُكتب رسالةٌ عربيّةٌ في الواجهة تُحاكي رسالةَ الخادم: الخادمُ يكتب
 * بالعربيّة أصلًا، والواجهةُ تعرض ما جاء.
 */
export class ApiError extends Error {
  readonly status: number
  readonly code: string

  constructor(status: number, code: string, message: string) {
    super(message)
    this.name = 'ApiError'
    this.status = status
    this.code = code
  }

  /** انتهت الجلسةُ أو سقط الرمز — الشاشةُ تُعيد إلى الدخول ولا تعرض خطأً. */
  get isUnauthenticated() {
    return this.status === 401
  }

  /** ممنوعٌ لا مجهول: الجلسةُ صالحةٌ والصلاحيّةُ ناقصة. */
  get isForbidden() {
    return this.status === 403
  }
}

/**
 * يقرأ جسمَ الردّ الخاطئ.
 *
 * ولا يثق بأنّه JSON: خطأٌ من الوكيل (Caddy) أو من طبقةٍ قبل التطبيق يخرج HTML،
 * و`res.json()` عليه يرمي `SyntaxError` تحلّ محلّ الخطأ الحقيقيّ — فيرى
 * الموظّفُ «Unexpected token <» بدل «انتهت الجلسة».
 */
export async function readProblem(res: Response): Promise<ApiError> {
  const fallback = `تعذّر إتمامُ الطلب (${res.status}).`

  try {
    const body = (await res.json()) as { code?: string; title?: string; detail?: string }

    return new ApiError(
      res.status,
      body.code ?? `http.${res.status}`,
      body.title ?? body.detail ?? fallback,
    )
  } catch {
    return new ApiError(res.status, `http.${res.status}`, fallback)
  }
}
